import React from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { Title } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/title/Title'
import { TitleSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'

import { useIsEngageDAProvider } from '../../../hooks/useIsEngageDAProvider'

const Container = styled.View(({ theme }) => ({
  marginBottom: theme.spacing['24px'],
}))

export const EndOfSessionDAPreText = () => {
  const { colors } = useTheme()
  const isProviderDAEngage = useIsEngageDAProvider()
  const intl = useIntl()

  if (!isProviderDAEngage) {
    return null
  }

  return (
    <Container>
      <Title
        text={intl.formatMessage({
          defaultMessage: 'Session details',
          description: 'Heading for session details section',
        })}
        size={TitleSize.LARGE}
      />
      <BodyText
        color={colors.textSecondary}
        text={intl.formatMessage({
          defaultMessage:
            'For compliance and billing accuracy, please indicate the correct information associated ' +
            'with this session below. Any intentional misrepresentation of this information could be ' +
            'considered billing fraud. Sessions older than 90 days cannot be submitted.',
          description: 'Text explaining the importance of accurate session details',
        })}
      />
    </Container>
  )
}
